<template>
  <div id="app">
    <div class="content-wrapper">
      <header>
        <h1>La dernière - Podcasts <span class="version">v{{ version }}</span></h1>
      </header>
      <main>
        <PodcastList @select-podcast="onSelectPodcast" :selectedPodcastId="selectedPodcast?.id" />
      </main>
      <AudioPlayer :podcast="selectedPodcast" @update-timestamp="onUpdateTimestamp" />
    </div>
  </div>
</template>

<script>
import PodcastList from './components/PodcastList.vue';
import AudioPlayer from './components/AudioPlayer.vue';
import { version } from './version';

export default {
  name: 'App',
  components: {
    PodcastList,
    AudioPlayer
  },
  data() {
    return {
      selectedPodcast: null,
      version: version
    };
  },
  methods: {
    onSelectPodcast(podcast) {
      this.selectedPodcast = podcast;
      this.savePodcastState();
    },
    onUpdateTimestamp(timestamp) {
      if (this.selectedPodcast) {
        this.selectedPodcast.timestamp = timestamp;
        this.savePodcastState();
      }
    },
    savePodcastState() {
      if (this.selectedPodcast) {
        localStorage.setItem('lastPodcast', JSON.stringify(this.selectedPodcast));
      }
    },
    loadPodcastState() {
      const savedPodcast = localStorage.getItem('lastPodcast');
      if (savedPodcast) {
        this.selectedPodcast = JSON.parse(savedPodcast);
      }
    }
  },
  mounted() {
    this.loadPodcastState();
  }
};
</script>

<style>
:root {
  --color-1: #10002b;
  --color-2: #240046;
  --color-3: #3c096c;
  --color-4: #5a189a;
  --color-5: #7b2cbf;
  --color-6: #9d4edd;
  --color-7: #c77dff;
  --color-8: #e0aaff;
  --background-color: #10002b;
  --text-color: #e0aaff;
}

@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap");

html, body {
  height: 100%;
  margin: 0;
  padding: 0;
}

body {
  background-color: var(--background-color);
  color: var(--text-color);
  padding: 80px; /* Add padding for desktop */
  box-sizing: border-box;
}

#app {
  font-family: "Roboto", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.content-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: var(--color-2);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
  border-radius: 20px; /* Add border-radius for desktop */
  overflow: hidden;
}

header {
  background-color: var(--color-3);
  color: var(--color-8);
  padding: 20px;
  text-align: center;
}

h1 {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 2px;
}

.version {
  font-size: 0.5em;
  vertical-align: baseline;
  margin-left: 5px;
  color: var(--color-7);
}

main {
  flex: 1;
  overflow-y: auto;
  padding: 20px; /* Add padding inside main */
}

@media (max-width: 1024px) {
  body {
    padding: 40px; /* Reduce padding for smaller screens */
  }
}

@media (max-width: 768px) {
  body {
    padding: 0; /* Remove padding for mobile */
  }

  .content-wrapper {
    border-radius: 0; /* Remove border-radius for mobile */
  }

  header {
    padding: 15px;
  }

  h1 {
    font-size: 24px;
  }

  .version {
    font-size: 0.6em;
  }

  main {
    padding: 15px; /* Adjust padding for mobile */
  }
}
</style>
